import { useEffect, useRef } from 'react'
import { gsap, ScrollTrigger } from '../lib/gsap'
import Logo from './Logo'

const BARS = 6

// v2's language changer: vertical brand bars sweep up, the language swaps while the screen
// is covered, then they sweep away. App calls coverRef.current(swap, nextLang).
export default function LangTransition({ coverRef }) {
  const root = useRef(null)

  useEffect(() => {
    const q = gsap.utils.selector(root)
    coverRef.current = (swap, next) =>
      new Promise((resolve) => {
        const bars = q('[data-bar]')
        q('[data-label]')[0].textContent = next === 'pt-BR' ? 'Português' : 'English'
        gsap
          .timeline({ onComplete: resolve })
          .set(root.current, { visibility: 'visible' })
          .fromTo(bars, { yPercent: 100 }, { yPercent: 0, duration: 0.7, ease: 'expo.inOut', stagger: { each: 0.05, from: 'center' } })
          .fromTo(q('[data-center]'), { opacity: 0, scale: 0.8 }, { opacity: 1, scale: 1, duration: 0.5, ease: 'expo.out' }, '-=0.25')
          .add(() => {
            swap()
            requestAnimationFrame(() => ScrollTrigger.refresh())
          })
          .to(q('[data-center]'), { opacity: 0, scale: 1.1, duration: 0.4, ease: 'expo.in' }, '+=0.35')
          .to(bars, { yPercent: -100, duration: 0.8, ease: 'expo.inOut', stagger: { each: 0.05, from: 'edges' } }, '-=0.1')
          .set(root.current, { visibility: 'hidden' })
      })
    return () => {
      coverRef.current = null
    }
  }, [coverRef])

  return (
    <div ref={root} className="pointer-events-none fixed inset-0 z-[350] flex" style={{ visibility: 'hidden' }} aria-hidden>
      {Array.from({ length: BARS }).map((_, i) => (
        <div
          key={i}
          data-bar
          className="h-full flex-1"
          style={{
            background: `linear-gradient(180deg, #2D3190 0%, #2D5CFF ${50 + i * 6}%, #0a0c12 100%)`,
            marginLeft: -1,
          }}
        />
      ))}
      <div data-center className="absolute inset-0 flex flex-col items-center justify-center gap-5">
        <Logo variant="white" className="h-16 w-16" />
        <span data-label className="font-display text-3xl font-semibold tracking-tight text-white sm:text-5xl" />
      </div>
    </div>
  )
}
